import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Link, useParams} from "react-router-dom";


const Iteam = () => {

    let {id: iteamName} = useParams();
    const [iteam, setIteam] = useState(null)
    useEffect(() => {
        console.log(iteamName)
        axios.get(`https://pokeapi.co/api/v2/item/${iteamName}`)
            .then(res => {
                console.log(res.data)
                setIteam(res.data)
            })
            .catch((err) => console.error(err))

    }, [iteamName]);
    if(!iteam) return <p>loading</p>
    return (
        <div>
            <h1>{iteam.name}</h1>
            <h1><img src={iteam.sprites.default} id={"ok"} alt={"idk"}/> </h1>
            <h1 id={"mess"}>{iteam.flavor_text_entries[0].text}</h1>
            <h1 id={"mess"}>{iteam.effect_entries[0].short_effect}</h1>
            <Link to={`/pokemons`}><button type={"button"}>Zpět na Vyhledavač</button></Link>
            <h2>cost : <label>{iteam.cost}</label></h2>
            <h2>Atributs</h2>
            <ul>
                {iteam.attributes.map((item,i) =>(
                    <li key={i}>{item.name}</li>

                ))}
            </ul>
        </div>
    );
};

export default Iteam;